import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';

import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';

type Props = {
	title: string;
	onClick?: () => void;
};

export const LoginButton = ({title, onClick}: Props) => {
	return (
		<>
			<Link
				onClick={onClick}
				href={internalLinkToHref('login-frontpage')}
				className={clsx(
					'transition-colors',
					'font-display',
					'text-primary-5',
					'border',
					'border-[#92A4C7]/40',
					'bg-[#92a4c7]/5',
					'hover:bg-[#92a4c7]/10',
					'text-sm',
					'flex',
					'items-center',
					'justify-center',
					'gap-2',
					'rounded-full',
					'px-4',
					'py-2.5',
					'shadow-[inset_0px_-2px_0px_0px_rgba(224,229,237,0.50)]',
				)}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="12"
					height="15"
					viewBox="0 0 12 15"
					fill="none"
				>
					<path
						d="M10.375 6.04167H9.93751V4.4375C9.93977 3.49065 9.60076 2.5747 8.9826 1.85747C8.36444 1.14025 7.50853 0.669802 6.57172 0.532326C5.6349 0.394851 4.67991 0.599559 3.88175 1.10894C3.08359 1.61832 2.49572 2.39826 2.22584 3.30583C2.19827 3.39776 2.18906 3.49422 2.19876 3.5897C2.20846 3.68518 2.23688 3.77781 2.28238 3.86232C2.32788 3.94682 2.38958 4.02153 2.46395 4.08219C2.53832 4.14284 2.62392 4.18826 2.71584 4.21583C2.90149 4.27153 3.10167 4.25119 3.27233 4.1593C3.44298 4.06741 3.57015 3.91148 3.62584 3.72583C3.79712 3.15621 4.16748 2.66715 4.66936 2.34789C5.17124 2.02863 5.77117 1.90046 6.3597 1.98676C6.94822 2.07306 7.4861 2.36807 7.87519 2.81798C8.26428 3.26788 8.47865 3.84268 8.47918 4.4375V5.75C8.47918 5.7883 8.47163 5.82623 8.45697 5.86162C8.44232 5.897 8.42083 5.92915 8.39375 5.95624C8.36667 5.98332 8.33451 6.00481 8.29913 6.01946C8.26374 6.03412 8.22581 6.04167 8.18751 6.04167H1.62501C1.31559 6.04167 1.01884 6.16458 0.800052 6.38337C0.58126 6.60217 0.458344 6.89891 0.458344 7.20833V13.3333C0.458344 13.6428 0.58126 13.9395 0.800052 14.1583C1.01884 14.3771 1.31559 14.5 1.62501 14.5H10.375C10.6844 14.5 10.9812 14.3771 11.2 14.1583C11.4188 13.9395 11.5417 13.6428 11.5417 13.3333V7.20833C11.5417 6.89891 11.4188 6.60217 11.2 6.38337C10.9812 6.16458 10.6844 6.04167 10.375 6.04167ZM4.83334 9.54167C4.83334 9.23225 4.95626 8.9355 5.17505 8.71671C5.39384 8.49792 5.69059 8.375 6.00001 8.375C6.30943 8.375 6.60618 8.49792 6.82497 8.71671C7.04376 8.9355 7.16668 9.23225 7.16668 9.54167C7.16545 9.74527 7.11096 9.945 7.00862 10.121C6.90629 10.297 6.75967 10.4432 6.58334 10.545V11.875C6.58334 12.0297 6.52188 12.1781 6.41249 12.2875C6.30309 12.3969 6.15472 12.4583 6.00001 12.4583C5.8453 12.4583 5.69693 12.3969 5.58753 12.2875C5.47813 12.1781 5.41668 12.0297 5.41668 11.875V10.545C5.24035 10.4432 5.09373 10.297 4.9914 10.121C4.88906 9.945 4.83457 9.74527 4.83334 9.54167Z"
						fill="#004379"
					/>
				</svg>

				{title}
			</Link>
		</>
	);
};
